import React, { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ArchiveIcon from '@mui/icons-material/Archive';
import CheckIcon from '@mui/icons-material/Check';
import { OrderItemEvent, OrderItemEventType } from 'models/order-item-events';
import { Order } from 'models/order';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import { OperationButtonsConfig, OrderType, StatusButtonsConfig } from 'models/order';
import {
    getOrderDetailsStatusButtons,
    getOrderDetailsOperationButtons,
} from 'components/order-details/utils/get-order-details-sub-nav-buttons';

type OrderStatusContextMenuProps = {
    order?: Order;
    onOrderItemEvent: (event: OrderItemEvent) => void;
};
const OrderStatusContextMenu: FC<OrderStatusContextMenuProps> = ({
    order,
    onOrderItemEvent,
}: OrderStatusContextMenuProps) => {
    const { t: translate } = useTranslation(['orders', 'workflow']);
    const currentUser = currentUserVar();
    const [statusConfig, setStatusConfig] = useState<StatusButtonsConfig>();
    const [showOperationButtons, setShowOperationButtons] = useState<OperationButtonsConfig>();

    useEffect(() => {
        if (order?.status) {
            setStatusConfig(getOrderDetailsStatusButtons(order.status));
            setShowOperationButtons(getOrderDetailsOperationButtons(order));
        }
    }, [order]);

    const handleContextMenuClick = (eventType: OrderItemEventType) => {
        if (order) {
            onOrderItemEvent({ order: order, eventType: eventType });
        }
    };

    return (
        <Fragment>
            {permissions.isInternalTechnician(currentUser.role) && statusConfig?.acceptByLab ? (
                <MenuItem onClick={() => handleContextMenuClick(OrderItemEventType.MANAGE_ACCEPTED_BY_LAB)}>
                    <ListItemIcon>
                        <CheckIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translate('orders:ACCEPTED_BY_LAB_BUTTON')}</ListItemText>
                </MenuItem>
            ) : undefined}
            {permissions.isInternalTechnician(currentUser.role) && statusConfig?.sentByLab ? (
                <MenuItem onClick={() => handleContextMenuClick(OrderItemEventType.MANAGE_SENT_BY_LAB)}>
                    <ListItemIcon>
                        <CheckIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translate('orders:SENT_BY_LAB_BUTTON')}</ListItemText>
                </MenuItem>
            ) : undefined}
            {permissions.isDentist(currentUser?.type) &&
            order?.type === OrderType.ACTION_BASED &&
            statusConfig?.approveOrder ? (
                <MenuItem onClick={() => handleContextMenuClick(OrderItemEventType.MANAGE_APPROVED)}>
                    <ListItemIcon>
                        <CheckIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translate('orders:APPROVED_BY_DENTIST_BUTTON')}</ListItemText>
                </MenuItem>
            ) : undefined}
            {!permissions.isExternalTechnician(currentUser.role) && showOperationButtons?.archiveOrder ? (
                <MenuItem onClick={() => handleContextMenuClick(OrderItemEventType.MANAGE_ARCHIVE)}>
                    <ListItemIcon>
                        <ArchiveIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translate('orders:ARCHIVE_ORDER')}</ListItemText>
                </MenuItem>
            ) : undefined}
        </Fragment>
    );
};

export default OrderStatusContextMenu;
